import { templateQueries } from './graphql'
import type { Template } from '@ztechapps/common.contract'
import type { UseDocumentProps } from '../useDocument/index'
import { useDocument } from '../useDocument/index'

/**
 * Get single template from the db
 */
export const useTemplateDocument = (props: Partial<UseDocumentProps>) => {
  return useDocument<Template>({
    ...templateQueries.singleConfig,
    ...props,
  })
}
